import { ClaimStatusSummary, PolicyCoverage } from './ClaimData'
import { ClaimRecordStatus } from './ClaimRecord'
import { Price } from './Price'

export interface GetQuoteArgs {
  claimRecordId: string
  termsAndConditionsAccepted: boolean
}

export interface QuoteData {
  status: QuoteStatus
  customerFacingStatus?: QuoteCustomerFacingStatus
  primaryCoverage: PolicyCoverage
  shippingCosts: Price
  quoteConfirmedAmount: Price

  // if status is ERROR
  errorType?: QuoteErrorType
  errorCode?: QuoteErrorCode
  errorMessage?: string
}

export enum QuoteStatus {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  DELETED = 'DELETED',
  SUBMITTED = 'SUBMITTED',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  ERROR = 'ERROR',
  CONNECTION_ERROR = 'CONNECTION_ERROR',
  RETRY = 'RETRY',
  RETRY_CANCELLED = 'RETRY_CANCELLED',
  CX_ACCEPTED = 'CX_ACCEPTED',
  CX_ACCEPT_FAILED = 'CX_ACCEPT_FAILED',
  CX_REFUSED = 'CX_REFUSED',
  CX_REFUSE_FAILED = 'CX_REFUSE_FAILED',
  SYSTEM_REFUSED = 'SYSTEM_REFUSED',
  CLAIM_NULLIFIED = 'CLAIM_NULLIFIED',
  CLOSED = 'CLOSED',
  NONE = 'NONE',
}

export enum QuoteCustomerFacingStatus {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  DELETED = 'DELETED',
  SUBMITTED = 'SUBMITTED',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  ERROR = 'ERROR',
  CONNECTION_ERROR = 'CONNECTION_ERROR',
  RETRY = 'RETRY',
  RETRY_CANCELLED = 'RETRY_CANCELLED',
  CX_ACCEPTED = 'CX_ACCEPTED',
  CX_ACCEPT_FAILED = 'CX_ACCEPT_FAILED',
  CX_REFUSED = 'CX_REFUSED',
  CX_REFUSE_FAILED = 'CX_REFUSE_FAILED',
  SYSTEM_REFUSED = 'SYSTEM_REFUSED',
  CLAIM_NULLIFIED = 'CLAIM_NULLIFIED',
  NONE = 'NONE',
}

export interface QuoteErrorData {
  errorType?: QuoteErrorType
  errorCode?: QuoteErrorCode
  errorMessage?: string
}

export enum QuoteErrorType {
  AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',
  COMMUNICATION_ERROR = 'COMMUNICATION_ERROR',
  CUSTOMER_FACING_ERROR = 'CUSTOMER_FACING_ERROR',
  RESTRICTED_PRODUCT_ERROR = 'RESTRICTED_PRODUCT_ERROR',
  TECHNICAL_ERROR = 'TECHNICAL_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
}

export enum QuoteErrorCode {
  BENEFICIARY_NOT_FOUND = 'BENEFICIARY_NOT_FOUND',
  INSUFFICIENT_BALANCE = 'INSUFFICIENT_BALANCE',
  INSURER_OFFLINE = 'INSURER_OFFLINE',
  GENERIC_ERROR = 'GENERIC_ERROR',
}

export interface QuoteStatusSummary extends QuoteErrorData {
  lastQuote?: boolean
  quoteId?: string
  status: QuoteStatus
  customerFacingStatus: QuoteCustomerFacingStatus
  claimRecordStatus?: ClaimRecordStatus
}

export interface StatusSummary {
  quote: QuoteStatusSummary
  claim: ClaimStatusSummary
}

export enum QuoteStep {
  REQUEST = 'REQUEST',
  SUBMIT = 'SUBMIT',
  OFFLINE = 'OFFLINE',
  ACCEPTED = 'ACCEPTED',
}
